import { Component, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { Router, RouterLink } from '@angular/router';
import { AccountMembership, APIService, MutationIntegrationActionsBodyInput } from 'app/API.service.custom';
import { ModifyRegisteredNumberComponent } from 'app/shared/profile/modify-registered-number/modify-registered-number.component';
import { UploadAndCropComponent } from 'app/shared/upload/upload-and-crop/upload-and-crop.component';
import { userLevelIntegrationList } from 'globals/constants';
import _ from 'lodash-es';
import { DialogConfig, DialogRef, DialogService } from 'app/shared/dialog';
import { Entity } from 'app/shared/models/evilo-models';
import { ToastrService } from 'ngx-toastr';
import { DataShareService } from 'services/data-share.service';
import { NgClass, TitleCasePipe } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { PushNotificationHealth, SignalService } from 'services/signal.service';
import { RedirectOauthLaunchService } from 'services/redirect-oauth-launch.service';
import { OAuthTransactionService } from 'services/oauth-transaction.service';

type PushDiagnosticSeverity = 'success' | 'warning' | 'error' | 'info';

interface PushDiagnosticCheck {
  key: string;
  label: string;
  value: string;
  severity: PushDiagnosticSeverity;
  recommendation?: string;
}

@Component({
    selector: 'app-user-actions',
    templateUrl: './user-actions.component.html',
    styleUrls: ['./user-actions.component.scss'],
    imports: [RouterLink, NgClass, ExtendedModule, TitleCasePipe]
})
export class UserActionsComponent implements OnInit {
  private redirectVersion = 0;
  activeAccountSubscription;
  activeAccount : AccountMembership = null;
  accounts : AccountMembership[] = [];

  integrationList = _.cloneDeep(userLevelIntegrationList);

  allRedirectUrls : any = null;
  workspaceQuery;

  pushDiagnosticsLoading = false;
  pushDiagnosticsError = '';
  pushDiagnosticsCheckedAt = '';
  pushHealth: PushNotificationHealth = null;
  pushDiagnosticChecks: PushDiagnosticCheck[] = [];
  pushDiagnosticSummary = 'Run the check to inspect notification delivery on this browser.';
  pushDiagnosticSeverity: PushDiagnosticSeverity = 'info';

  constructor(
    private dataService: DataShareService,
    private config: DialogConfig,
    private dialog: DialogRef,
    private router: Router,
    private sidebarService: DialogService,
    private toastr: ToastrService,
    private api: APIService,
    private signalService: SignalService,
    private redirectOauth: RedirectOauthLaunchService,
    private transactions: OAuthTransactionService,
  ) { }

  ngOnInit(): void {
    this.activeAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
      if (param) {
        if (this.activeAccount && (this.activeAccount.accountId !== param.accountId || this.activeAccount.userId !== param.userId)) {
          this.transactions.cancelForAccount(this.activeAccount.accountId);
          this.redirectVersion++;
          this.allRedirectUrls = null;
        }
        this.activeAccount = param;
        console.log("in dashboard new component, activeAccount is ", this.activeAccount);
        if (this.activeAccount.accountId == environment.salesmaxAccountId) {
            let matchIndex = this.integrationList.findIndex(item => item.id == 'GMEET_EXTERNAL');
            if(matchIndex != null && matchIndex != -1){
              this.integrationList[matchIndex].id = "GMEET";
            }
        }
        this.getAllRedirectUrls();
        void this.runPushDiagnostics();
      }
    })
    let configData = null;
    if (this.config && this.config.data) {
      configData = this.config.data;
      if (configData.accounts) {
        this.accounts = configData.accounts;
        for(let _i = 0; _i < this.accounts.length; _i++){
          if(this.accounts[_i].account && this.accounts[_i].account.trialAccountEndDate){
            if(this.accounts[_i].account.trialAccountEndDate < ((new Date()).toISOString()))
              this.accounts[_i]["isExpired"] = true;
          }
        }
        this.accounts.sort(this.customSort);
      }
    }
  }

  customSort(a, b) {
    // If a is expired but b is not, move b to a lower index (b comes first).
    if (a.isExpired && !b.isExpired) {
      return 1;
    }
    // If b is expired but a is not, move a to a lower index (a comes first).
    if (!a.isExpired && b.isExpired) {
      return -1;
    }
    // Otherwise, maintain the original order.
    return 0;
  }

  ngOnDestroy(): void {
    if (this.activeAccountSubscription && !this.activeAccountSubscription.closed)
      this.activeAccountSubscription.unsubscribe();
  }

  signOut(){
    this.dialog?.close();
    this.router.navigate(['/sign-out']);
  }

  manageWorkspace(){
    this.dialog?.close();
    this.router.navigate(['/account/manage-account']);
  }

  closeDialog(){
    this.dialog?.close();
  }

  changeActiveAccount(account : AccountMembership){
    let toReturn = {action : 'switch', item : account}
    this.dialog.close(toReturn);
  }

  switchToAdmin(){
    let toReturn = {action : 'admin'}
    this.dialog.close(toReturn);
  }

  changeRegisteredNumber(){
    this.dialog?.close();
    this.sidebarService.open(ModifyRegisteredNumberComponent, {
      data: {  }
    });
  }

  showProfilePicUpload() {
    this.dialog?.close();
    let entity: Entity = { entityID: this.activeAccount.userId, entityType: 'EMPLOYEE' }
    this.sidebarService.open(UploadAndCropComponent, {
      data: { title: "Uploading Profile Picture", docType: "user-profile-picture", uploadedToEntity: entity }
    });
  }

  goToIntegration(integration){
    if(integration && (integration.id == 'GMAIL' || integration.id == 'GMEET' || integration.id == 'GMEET_EXTERNAL')){
      const oauthUrl = this.allRedirectUrls?.[integration.id];
      if(oauthUrl && oauthUrl.url &&  oauthUrl.url != "")
        void this.redirectOauth.launchRedirect(integration.id, oauthUrl.url, this.activeAccount).then(result => {
          if (result.ok === false) this.toastr.error(result.message || 'Authorization did not finish. Start the connection again.');
        });
    }
  }

  getAllRedirectUrls(){
    const version = this.redirectVersion;
    let b = <MutationIntegrationActionsBodyInput>{};
    b.action = "GET_CONNECTION_URL";
    b.accountId = this.activeAccount.accountId;
    b.data = "";
    b.networkType = "";
    this.api.IntegrationActions(undefined, b).then(event => {
      if (version !== this.redirectVersion) return;
      console.log("GET_CONNECTION_URL response is ", event)
      if(event){ 
        let resp = JSON.parse(event);
        console.log("integration event.result is ", resp);
        this.allRedirectUrls = resp;
      }
    })
      .catch(e => {
        console.log('Error Fetching Integration Status', e);
        this.showErrorInToastr(e, 'Error Fetching Integration Status')
      });
  }

  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        console.log(e.errors[_i].message);
      }
    }
  }

  async runPushDiagnostics(): Promise<void> {
    if (this.pushDiagnosticsLoading) {
      return;
    }
    this.pushDiagnosticsLoading = true;
    this.pushDiagnosticsError = '';
    try {
      this.pushHealth = await this.signalService.getPushHealth();
      this.pushDiagnosticChecks = this.buildPushDiagnosticChecks(this.pushHealth);
      this.updatePushDiagnosticSummary();
      this.pushDiagnosticsCheckedAt = new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    } catch (error) {
      console.warn('Unable to run notification diagnostics.', error);
      this.pushDiagnosticsError = 'The notification check could not finish. Reload this page and try again.';
      this.pushDiagnosticSummary = 'Notification status is unavailable.';
      this.pushDiagnosticSeverity = 'error';
    } finally {
      this.pushDiagnosticsLoading = false;
    }
  }

  async repairPushIdentity(): Promise<void> {
    const expectedExternalId = this.activeAccount?.userId;
    if (!expectedExternalId || this.pushDiagnosticsLoading) {
      return;
    }
    this.pushDiagnosticsLoading = true;
    this.pushDiagnosticsError = '';
    try {
      await this.signalService.setExternalId(expectedExternalId);
    } catch (error) {
      console.warn('Unable to repair OneSignal identity.', error);
      this.pushDiagnosticsError = 'We could not reconnect this browser to your user ID. Reload and try again.';
    } finally {
      this.pushDiagnosticsLoading = false;
    }
    await this.runPushDiagnostics();
  }

  get canRepairPushIdentity(): boolean {
    return !!this.activeAccount?.userId
      && this.pushDiagnosticChecks.some((check) => check.key === 'identity' && check.severity === 'error');
  }

  private buildPushDiagnosticChecks(health: PushNotificationHealth): PushDiagnosticCheck[] {
    const checks: PushDiagnosticCheck[] = [];
    const expectedExternalId = this.activeAccount?.userId || null;

    checks.push({
      key: 'network',
      label: 'Internet connection',
      value: health.online ? 'Online' : 'Offline',
      severity: health.online ? 'success' : 'error',
      recommendation: health.online ? null : 'Reconnect to the internet, then run this check again.',
    });

    checks.push({
      key: 'browser-support',
      label: 'Browser push support',
      value: health.browserSupported ? 'Supported' : 'Not supported',
      severity: health.browserSupported ? 'success' : 'error',
      recommendation: health.browserSupported
        ? null
        : 'Use a current version of Chrome, Edge, Firefox, or Safari with service workers enabled.',
    });

    checks.push({
      key: 'secure-context',
      label: 'Secure website',
      value: health.secureContext ? 'Secure' : 'Not secure',
      severity: health.secureContext ? 'success' : 'error',
      recommendation: health.secureContext ? null : 'Web push requires HTTPS, except for supported localhost testing.',
    });

    checks.push(this.getSdkCheck(health));
    checks.push(this.getPermissionCheck(health.browserPermission));

    checks.push({
      key: 'service-worker',
      label: 'OneSignal service worker',
      value: health.serviceWorkerRegistered === true
        ? 'Registered'
        : health.serviceWorkerRegistered === false ? 'Not found' : 'Could not inspect',
      severity: health.serviceWorkerRegistered === true
        ? 'success'
        : health.serviceWorkerRegistered === false ? 'error' : 'warning',
      recommendation: health.serviceWorkerRegistered === true
        ? null
        : 'Reload the page. If it remains missing, check browser extensions and service-worker errors before clearing site data.',
    });

    checks.push({
      key: 'subscription',
      label: 'Push subscription',
      value: health.subscribed === true ? 'Subscribed' : health.subscribed === false ? 'Not subscribed' : 'Unknown',
      severity: health.subscribed === true ? 'success' : health.subscribed === false ? 'error' : 'warning',
      recommendation: health.subscribed === true
        ? null
        : 'Allow notifications for this site, reload the page, and run the check again.',
    });

    checks.push({
      key: 'subscription-id',
      label: 'Subscription ID',
      value: health.subscriptionId || 'Missing',
      severity: health.subscriptionId ? 'success' : 'error',
      recommendation: health.subscriptionId
        ? null
        : 'OneSignal has not created a usable browser subscription. Reload after allowing notifications.',
    });

    checks.push(this.getIdentityCheck(health.sdkExternalUserId, expectedExternalId));

    const isMac = typeof navigator !== 'undefined' && /Mac/i.test(navigator.platform || navigator.userAgent);
    checks.push({
      key: 'device-settings',
      label: isMac ? 'macOS notification settings' : 'Device notification settings',
      value: 'Manual check required',
      severity: 'info',
      recommendation: isMac
        ? 'Open System Settings → Notifications → Google Chrome. Enable notifications and turn off Focus/Do Not Disturb while testing.'
        : 'Confirm notifications are enabled for the browser at the operating-system level and that Focus/Do Not Disturb is off.',
    });

    checks.push({
      key: 'delivery-test',
      label: 'End-to-end delivery',
      value: 'Support can verify',
      severity: 'info',
      recommendation: health.subscriptionId
        ? `If notifications still do not arrive, contact support and share Subscription ID ${health.subscriptionId}.`
        : 'Resolve the missing subscription above before contacting support.',
    });

    return checks;
  }

  private getSdkCheck(health: PushNotificationHealth): PushDiagnosticCheck {
    if (health.sdkState === 'ready') {
      return { key: 'sdk', label: 'OneSignal SDK', value: 'Loaded', severity: 'success' };
    }
    if (health.sdkState === 'disabled') {
      return {
        key: 'sdk',
        label: 'OneSignal SDK',
        value: 'Disabled in this environment',
        severity: 'warning',
        recommendation: 'Notification diagnostics run only where OneSignal is enabled, normally the production site.',
      };
    }
    if (health.sdkState === 'failed') {
      return {
        key: 'sdk',
        label: 'OneSignal SDK',
        value: `Failed (${health.sdkFailureReason || 'unknown reason'})`,
        severity: 'error',
        recommendation: 'Disable ad blockers for this site and confirm cdn.onesignal.com is allowed by the network.',
      };
    }
    return {
      key: 'sdk',
      label: 'OneSignal SDK',
      value: health.sdkState === 'loading' ? 'Still loading' : 'Not initialized',
      severity: 'warning',
      recommendation: 'Wait a few seconds and run the check again.',
    };
  }

  private getPermissionCheck(permission: NotificationPermission | 'unsupported'): PushDiagnosticCheck {
    if (permission === 'granted') {
      return { key: 'permission', label: 'Website permission', value: 'Allowed', severity: 'success' };
    }
    if (permission === 'denied') {
      return {
        key: 'permission',
        label: 'Website permission',
        value: 'Blocked',
        severity: 'error',
        recommendation: 'In the browser site settings, change Notifications to Allow, then reload this page.',
      };
    }
    if (permission === 'default') {
      return {
        key: 'permission',
        label: 'Website permission',
        value: 'Not decided',
        severity: 'warning',
        recommendation: 'Allow notifications when the browser asks. If no prompt appears, open the browser site settings.',
      };
    }
    return {
      key: 'permission',
      label: 'Website permission',
      value: 'Unsupported',
      severity: 'error',
      recommendation: 'This browser or browsing mode does not provide the Notifications API.',
    };
  }

  private getIdentityCheck(actualExternalId: string, expectedExternalId: string): PushDiagnosticCheck {
    if (!expectedExternalId) {
      return {
        key: 'identity',
        label: 'Notification user identity',
        value: actualExternalId || 'Could not determine expected user',
        severity: 'warning',
        recommendation: 'Reload the workspace so the signed-in user can be identified.',
      };
    }
    if (!actualExternalId) {
      return {
        key: 'identity',
        label: 'Notification user identity',
        value: 'External ID is missing',
        severity: 'error',
        recommendation: `Reconnect this browser to the signed-in user (${expectedExternalId}).`,
      };
    }
    const matches = actualExternalId === expectedExternalId;
    return {
      key: 'identity',
      label: 'Notification user identity',
      value: matches ? actualExternalId : `Mismatch: ${actualExternalId}`,
      severity: matches ? 'success' : 'error',
      recommendation: matches
        ? null
        : `Expected ${expectedExternalId}. Use Repair identity, then run the check again.`,
    };
  }

  private updatePushDiagnosticSummary(): void {
    const errorCount = this.pushDiagnosticChecks.filter((check) => check.severity === 'error').length;
    const warningCount = this.pushDiagnosticChecks.filter((check) => check.severity === 'warning').length;
    if (errorCount > 0) {
      this.pushDiagnosticSeverity = 'error';
      this.pushDiagnosticSummary = `${errorCount} notification ${errorCount === 1 ? 'problem needs' : 'problems need'} attention.`;
    } else if (warningCount > 0) {
      this.pushDiagnosticSeverity = 'warning';
      this.pushDiagnosticSummary = `${warningCount} notification ${warningCount === 1 ? 'check needs' : 'checks need'} attention.`;
    } else {
      this.pushDiagnosticSeverity = 'success';
      this.pushDiagnosticSummary = 'Browser notification checks passed. Complete the two manual delivery checks below.';
    }
  }

}
